var finansudd = finansudd || {};

finansudd.video = new function(){

    var self = this;


    this.openVideoOverlay = function (selector) {
		selector.click(function(e) {
			e.preventDefault();
			var $this = $(this),
				videoId = $this.attr('data-video-src');
				videoWidth = (window.innerWidth * 0.8),
				videoHeight = videoWidth / (16/9);

			var videoKode = $('<iframe>').attr({'width': videoWidth, 'height': videoHeight, 'src': "https://www.youtube.com/embed/"+videoId+"?rel=0&autohide=1&showinfo=0&autoplay=1"});

			novicell.overlay.set({'content':videoKode,'class':'foo'})
			$('#ncOverlay-content').css('height', videoHeight + 'px');
		});
	};


};
